<ul class="lh-rows">
  <li *ngFor="let article of articles; trackBy: trackById">
    <a class="lh-row" [routerLink]="['/', modulePath, article.lang, article.slug]">
      <span class="lh-row-text">
        <span class="lh-row-title">{{ article.title }}</span>
        <span class="lh-row-summary" *ngIf="showSummary && article.summary">{{ article.summary }}</span>
      </span>
      <span class="lh-row-arrow" aria-hidden="true">→</span>
    </a>
  </li>
</ul>
